<script setup>
import cmsApiDriveService from "@/services/http/api-drive/cms";
import { loadPageWithLoader } from "@/utils/webpack-helper";
import { useContextStore } from "@/store/context";
import { useAxiosHelper } from "@/utils/axios-helper";

const { query, path } = useRoute();
const params = {};
const { layout } = storeToRefs(useContextStore());
const { getHead, throwIfAxiosError } = useAxiosHelper();

const component = computed(() => {
  return loadPageWithLoader(
    lazyComponents[
      `/components/pages/infos-et-services/page-contenu/${layout.value}.vue`
    ]
  );
});

if (path === "/infos-et-services/prospectus") {
  await navigateTo("/prospectus", { replace: true, redirectCode: 301 });
}

if (query.preview) {
  params.preview = query.preview;
}

const { data: response, error } = await useAsyncData((app) =>
  app.$apiDrive.use(cmsApiDriveService).fetchContent(path, params)
);

throwIfAxiosError(error);

useHead(() => {
  return {
    ...getHead(response)
  };
});
</script>

<template>
  <component
    :is="component"
    :cms-reponse="response"
  />
</template>

<style lang="scss" scoped>
</style>
